import { removeBlankFields } from 'react-redux-app/lib/modules/core/utils';
import { getPromotedSite, getWLSiteId, replacePromotedSite } from '../utils';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__REQUEST,
  ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__SUCCESS,
  ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__FAIL,

  ACTION_LOAD_AFFILIATE_TOOLS__REQUEST,
  ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS,
  ACTION_LOAD_AFFILIATE_TOOLS__FAIL,

  ACTION_LOAD_ROTATING_BANNER__REQUEST,
  ACTION_LOAD_ROTATING_BANNER__SUCCESS,
  ACTION_LOAD_ROTATING_BANNER__FAIL,

  ACTION_LOAD_AFFILIATE_TOOL_CONTENT__REQUEST,
  ACTION_LOAD_AFFILIATE_TOOL_CONTENT__SUCCESS,
  ACTION_LOAD_AFFILIATE_TOOL_CONTENT__FAIL,

  ACTION_LOAD_CUSTOM_BANNERS__REQUEST,
  ACTION_LOAD_CUSTOM_BANNERS__SUCCESS,
  ACTION_LOAD_CUSTOM_BANNERS__FAIL,

  ACTION_ADD_CUSTOM_BANNER,
  ACTION_CREATE_CUSTOM_BANNER__REQUEST,
  ACTION_CREATE_CUSTOM_BANNER__SUCCESS,
  ACTION_CREATE_CUSTOM_BANNER__FAIL,

  ACTION_EDIT_CUSTOM_BANNER__REQUEST,
  ACTION_EDIT_CUSTOM_BANNER__SUCCESS,
  ACTION_EDIT_CUSTOM_BANNER__FAIL,

  ACTION_DELETE_CUSTOM_BANNER__REQUEST,
  ACTION_DELETE_CUSTOM_BANNER__SUCCESS,
  ACTION_DELETE_CUSTOM_BANNER__FAIL,

  ACTION_ADD_LAUNCH_AFFILIATE_TOOL_URL,
  ACTION_ADD_PROMOTED_SITES,

  ACTION_ADD_SELECTED_PARAMS,
  ACTION_CLEAR_SELECTED_PARAMS,
} from '../actionTypes';

import { AFFILIATE_TOOLS_SCHEMA, CUSTOM_BANNERS_SCHEMA } from '../schemas';

import { getRequestStartTime } from '../selectors';


export const actionAddLaunchAffiliateToolUrl = launchAffiliateToolUrl => ({
  type: ACTION_ADD_LAUNCH_AFFILIATE_TOOL_URL,
  payload: { launchAffiliateToolUrl },
});

export const actionAddPromotedSites = promotedSites => ({
  type: ACTION_ADD_PROMOTED_SITES,
  payload: { promotedSites },
});

export const actionLoadAffiliateToolsFilterStructureSuccess = affiliateToolsFilterStructure => ({
  type: ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__SUCCESS,
  payload: { affiliateToolsFilterStructure },
});

export const actionLoadAffiliateToolsFilterStructureFail = error => ({
  type: ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__FAIL,
  payload: { error },
});

export const actionLoadAffiliateToolsFilterStructureRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/affiliate_tool/filter_structure',
      {}
    ).then(
      result => {
        dispatch(actionLoadAffiliateToolsFilterStructureSuccess(result));
      },
      error => {
        dispatch(actionLoadAffiliateToolsFilterStructureFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionLoadAffiliateToolsSuccess = (
  affiliateTools, affiliateToolsType, affiliateToolsOrder
) => ({
  type: ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS,
  payload: { affiliateTools, affiliateToolsType, affiliateToolsOrder },
});

export const actionLoadAffiliateToolsFail = error => ({
  type: ACTION_LOAD_AFFILIATE_TOOLS__FAIL,
  payload: { error },
});

export const actionLoadAffiliateToolsRequest = filter => (
  (dispatch, getState, { apiClientHelper }) => {
    const startTime = Date.now();
    dispatch({
      type: ACTION_LOAD_AFFILIATE_TOOLS__REQUEST,
      payload: { affiliateToolsType: filter.type, startTime },
    });

    return apiClientHelper.get(
      '/rest/webmaster/affiliate_tool',
      { params: replacePromotedSite(removeBlankFields(filter)) },
      AFFILIATE_TOOLS_SCHEMA
    ).then(
      ({ entities, result }) => {
        if (startTime < getRequestStartTime(getState())) {
          return;
        }
        dispatch(actionLoadAffiliateToolsSuccess(
          entities.affiliateTools, filter.type, result.items
        ));
      },
      error => {
        dispatch(actionLoadAffiliateToolsFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionLoadRotatingBannerSuccess = rotatingBanner => ({
  type: ACTION_LOAD_ROTATING_BANNER__SUCCESS,
  payload: { rotatingBanner },
});

export const actionLoadRotatingBannerFail = error => ({
  type: ACTION_LOAD_ROTATING_BANNER__FAIL,
  payload: { error },
});

export const actionLoadRotatingBannerRequest = (
  ids,
  affiliateToolType,
  campaignId,
  promotedSite,
  width,
  height
) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_ROTATING_BANNER__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/affiliate_tool/random',
      {
        params: removeBlankFields({
          ids,
          affiliateToolType,
          campaignId,
          promotedSite: getPromotedSite(promotedSite),
          wlId: getWLSiteId(promotedSite),
          width,
          height,
        }),
      }
    ).then(
      ({ value }) => {
        dispatch(actionLoadRotatingBannerSuccess(value));
      },
      error => {
        dispatch(actionLoadRotatingBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionLoadAffiliateToolContentSuccess = (id, content) => ({
  type: ACTION_LOAD_AFFILIATE_TOOL_CONTENT__SUCCESS,
  payload: { id, content },
});

export const actionLoadAffiliateToolContentFail = (id, error) => ({
  type: ACTION_LOAD_AFFILIATE_TOOL_CONTENT__FAIL,
  payload: { id, error },
});

export const actionLoadAffiliateToolContentRequest = (
  uuid, // Note: generate it yourself or just use the affiliateToolId
  affiliateToolId,
  campaignId,
  promotedSite,
  targetLang,
  width,
  height,
  customParams = null
) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_AFFILIATE_TOOL_CONTENT__REQUEST,
      payload: { id: uuid },
    });

    return apiClientHelper.get(
      '/rest/webmaster/affiliate_tool/content',
      {
        params: removeBlankFields({
          affiliateToolId,
          campaignId,
          promotedSite: getPromotedSite(promotedSite),
          wlId: getWLSiteId(promotedSite),
          targetLang,
          width,
          height,
          cp: customParams,
        }),
      }
    ).then(
      ({ value }) => {
        dispatch(actionLoadAffiliateToolContentSuccess(uuid, value));
      },
      error => {
        dispatch(actionLoadAffiliateToolContentFail(uuid, error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionLoadCustomBannersSuccess = customBanners => ({
  type: ACTION_LOAD_CUSTOM_BANNERS__SUCCESS,
  payload: { customBanners },
});

export const actionLoadCustomBannersFail = error => ({
  type: ACTION_LOAD_CUSTOM_BANNERS__FAIL,
  payload: { error },
});

export const actionLoadCustomBannersRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_CUSTOM_BANNERS__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/custom_banner',
      {},
      CUSTOM_BANNERS_SCHEMA
    ).then(
      ({ entities }) => {
        dispatch(actionLoadCustomBannersSuccess(entities.customBanners || {}));
      },
      error => {
        dispatch(actionLoadCustomBannersFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionAddCustomBanner = customBanner => ({
  type: ACTION_ADD_CUSTOM_BANNER,
  payload: { customBanner },
});

export const actionCreateCustomBannerSuccess = () => ({
  type: ACTION_CREATE_CUSTOM_BANNER__SUCCESS,
});

export const actionCreateCustomBannerFail = error => ({
  type: ACTION_CREATE_CUSTOM_BANNER__FAIL,
  payload: { error },
});

export const actionCreateCustomBannerRequest = ({
  ageRange,
  backgroundColor,
  bannerName,
  bannerLanguage,
  borderColor,
  borderWidth,
  cid,
  columns,
  onlineOnly,
  promochat,
  showProfileInfo,
  linkColor,
  photoBorderColor,
  photoBorderWidth,
  profileInfoPosition,
  profileInfoAreaWidth,
  rows,
  site,
  textColor,
  thumbnailSize, // Note: only width or height, cuz thumb is considered to be square
}) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_CREATE_CUSTOM_BANNER__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/custom_banner',
      {
        data: removeBlankFields({
          ageRange,
          backgroundColor,
          bannerName,
          bannerLanguage,
          borderColor,
          borderWidth,
          cid,
          columns,
          geoTargetTitleColor: '#000000', // Note: unused
          onlineOnly,
          promochat,
          showProfileInfo,
          linkColor,
          photoBorderColor,
          photoBorderWidth,
          profileInfoPosition,
          profileInfoAreaWidth,
          rows,
          site: getPromotedSite(site),
          wlId: getWLSiteId(site),
          titleColor: '#000000', // Note: unused
          textColor,
          thumbnailSize,
          showGeoTargetTitle: '0', // Note: unused
        }),
      }
    ).then(
      result => {
        dispatch(actionCreateCustomBannerSuccess());
        dispatch(actionAddCustomBanner(result));
      },
      error => {
        dispatch(actionCreateCustomBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionEditCustomBannerSuccess = () => ({
  type: ACTION_EDIT_CUSTOM_BANNER__SUCCESS,
});

export const actionEditCustomBannerFail = error => ({
  type: ACTION_EDIT_CUSTOM_BANNER__FAIL,
  payload: { error },
});

export const actionEditCustomBannerRequest = ({
  ageRange,
  backgroundColor,
  bannerName,
  bannerLanguage,
  borderColor,
  borderWidth,
  cid,
  columns,
  id,
  onlineOnly,
  promochat,
  showProfileInfo,
  linkColor,
  photoBorderColor,
  photoBorderWidth,
  profileInfoPosition,
  profileInfoAreaWidth,
  rows,
  site,
  wlId,
  textColor,
  thumbnailSize, // Note: only width or height, cuz thumb is considered to be square
}) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_EDIT_CUSTOM_BANNER__REQUEST,
    });

    return apiClientHelper.put(
      `/rest/webmaster/custom_banner/${id}`,
      {
        data: removeBlankFields({
          ageRange,
          backgroundColor,
          bannerName,
          bannerLanguage,
          borderColor,
          borderWidth,
          cid,
          columns,
          geoTargetTitleColor: '#000000', // Note: unused
          onlineOnly,
          promochat,
          showProfileInfo,
          linkColor,
          photoBorderColor,
          photoBorderWidth,
          profileInfoPosition,
          profileInfoAreaWidth,
          rows,
          site,
          wlId,
          titleColor: '#000000', // Note: unused
          textColor,
          thumbnailSize,
          showGeoTargetTitle: '0', // Note: unused
        }),
      }
    ).then(
      result => {
        dispatch(actionEditCustomBannerSuccess());
        dispatch(actionAddCustomBanner(result));
      },
      error => {
        dispatch(actionEditCustomBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionDeleteCustomBannerSuccess = bannerId => ({
  type: ACTION_DELETE_CUSTOM_BANNER__SUCCESS,
  payload: { bannerId },
});

export const actionDeleteCustomBannerFail = error => ({
  type: ACTION_DELETE_CUSTOM_BANNER__FAIL,
  payload: { error },
});

export const actionDeleteCustomBannerRequest = bannerId => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_DELETE_CUSTOM_BANNER__REQUEST,
    });

    return apiClientHelper.del(
      `/rest/webmaster/custom_banner/${bannerId}`,
      {}
    ).then(
      () => {
        dispatch(actionDeleteCustomBannerSuccess(bannerId));
      },
      error => {
        dispatch(actionDeleteCustomBannerFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);

export const actionAddSelectedParams = selectedParams => ({
  type: ACTION_ADD_SELECTED_PARAMS,
  payload: { selectedParams },
});

export const actionClearSelectedParams = selectedParamNames => ({
  type: ACTION_CLEAR_SELECTED_PARAMS,
  payload: { selectedParamNames },
});
